<div class="timeline-title">
  <ng-container i18n>Activity Log</ng-container>
</div>
<div class="timeline-content">
  <div class="action-item" *ngFor="let item of timeline">
    <ng-container *ngIf="item.action | signStatus; let status">
      <div class="action-icon" [ngClass]="status.bgColor">
        <i [ngClass]="status.icon"></i>
      </div>
      <div class="action-content">
        <ul class="dot-segments-list">
          <li class="action-name text-capitalize" [ngClass]="'text-' + status.color">
            <ng-container [ngSwitch]="item.action">
              <ng-container *ngSwitchCase="'sent'" i18n>Received by</ng-container>
              <ng-container *ngSwitchCase="'delivering'" i18n>Delivering</ng-container>
              <ng-container *ngSwitchCase="'failed'" i18n>Failed to deliver</ng-container>
              <ng-container *ngSwitchDefault> {{ item.action }} by </ng-container>
            </ng-container>
          </li>
          <li class="action-user">{{ getSigner(item.user, contract)?.name }}</li>
        </ul>
        <ul class="dot-segments-list text-light">
          <li>{{ item.date | epoch : 'date' }}</li>
          <li>{{ item.date | epoch : 'time' }}</li>
        </ul>
      </div>
    </ng-container>
  </div>
</div>
